// GQL
import { gql } from '@apollo/client';
import { NEW_ACCIDENT } from '../fragments/accident';
import { NEW_ORDER } from '../fragments/orders';

// CREATE_NEW_ACCIDENT eliminado (Bloque C-Limpieza 2026-05-08): sustituido
// por SAVE_ACCIDENT atómica.
//
// CREATE_NEW_ATTENTION_ACCIDENT, UPDATE_NEW_ATTENTION_ACCIDENT,
// UPDATE_ACCIDENT_ORDER_RELATIONSHIPS siguen vivas (entidad AttentionAccident
// + relaciones M:N gestionadas por separado).
export const CREATE_NEW_ATTENTION_ACCIDENT = gql`
  mutation CreateAttentionAccident($input: NewAttentionAccident!) {
    createAttentionAccident(input: $input) {
      id
      noticeConservationCenterDate
      arrivalConservationCenterDate
      departureConservationCenterDate
      noticeSquadBoysDate
      arrivalSquadBoysDate
      departureSquadBoysDate
      noticeRoadTeamDate
      arrivalRoadTeamDate
      departureRoadTeamDate
      noticeControlCenterDate
      arrivalControlCenterDate
      departureControlCenterDate
      noticeAmbulanceCraneAssistanceDate
      arrivalAmbulanceCraneAssistanceDate
      departureAmbulanceCraneAssistanceDate
      otherName
      noticeOtherDate
      arrivalOtherDate
      departureOtherDate
      accidentIDs
    }
  }
`;

export const UPDATE_NEW_ATTENTION_ACCIDENT = gql`
  mutation UpdateAttentionAccident($input: UpdateAttentionAccident!) {
    updateAttentionAccident(input: $input) {
      id
      noticeConservationCenterDate
      arrivalConservationCenterDate
      departureConservationCenterDate
      noticeSquadBoysDate
      arrivalSquadBoysDate
      departureSquadBoysDate
      noticeRoadTeamDate
      arrivalRoadTeamDate
      departureRoadTeamDate
      noticeControlCenterDate
      arrivalControlCenterDate
      departureControlCenterDate
      noticeAmbulanceCraneAssistanceDate
      arrivalAmbulanceCraneAssistanceDate
      departureAmbulanceCraneAssistanceDate
      otherName
      noticeOtherDate
      arrivalOtherDate
      departureOtherDate
      accidentIDs
    }
  }
`;

export const CREATE_NEW_IMAGE = gql`
  mutation createImage($input: NewImage!) {
    createImage(input: $input) {
      id
      name
      creatingDate
      # Storage migration 2026-05: dual fields, exactly one is non-null per image
      cloudinaryPublicId
      storageKey
      storageProvider
      # Migración Hetzner: URL pública del objeto (null si legacy). El frontend
      # reconstruye la fetch URL con el SDK Cloudinary (ver utils/cloudinary.ts).
      publicUrl
      # T56 fix: Campos para sketch completo
      sketchSvg
      sketchFabricJson
      orderIDs
    }
  }
`;

export const DELETE_MANY_IMAGES = gql`
  mutation DeleteManyImages($ids: [ID!]) {
    deleteManyImagesByIds(ids: $ids) {
      id
    }
  }
`;

// T56 fix: Mutation para actualizar datos del sketch
export const UPDATE_IMAGE_SKETCH = gql`
  mutation UpdateImageSketch($id: ID!, $input: UpdateImageSketch!) {
    updateImageSketch(id: $id, input: $input) {
      id
      name
      sketchSvg
      sketchFabricJson
    }
  }
`;

// UPDATE_ACCIDENT_ORDER eliminado (Bloque C-Limpieza 2026-05-08):
// sustituido por SAVE_ACCIDENT atómica que cubre Order + Accident en un
// $transaction Prisma único, eliminando el deadlock P2034 que motivaba
// skipOrderSync.

export const UPDATE_ACCIDENT_ORDER_RELATIONSHIPS = gql`
  mutation UpdateAccidentRelationships($input: UpdateAccidentRelationships!) {
    updateAccidentRelationships(input: $input) {
      ...NewAccident
    }
  }
  ${NEW_ACCIDENT}
`;

/**
 * Endpoint unificado que reemplaza CREATE_NEW_ORDER + CREATE_NEW_ACCIDENT +
 * UPDATE_ORDER + UPDATE_ACCIDENT_ORDER + UPDATE_ORDER_RELATIONSHIPS del flujo
 * EditAccident/AddVehicle. Ver PLAN-SAVE-ENTITY-UNIFIED.md §2.4.
 */
export const SAVE_ACCIDENT = gql`
  mutation SaveAccident($input: SaveAccidentInput!) {
    saveAccident(input: $input) {
      order {
        ...NewOrder
      }
      accident {
        ...NewAccident
      }
    }
  }
  ${NEW_ORDER}
  ${NEW_ACCIDENT}
`;
